import {getClient} from './contentfulClient'
import moment from 'moment';
import {getCurrentBrowserFingerPrint} from '@rajesh896/broprint.js';

let preferredLanguage = localStorage.getItem('prefLang');

import {addToast, addToastWithGa_id} from './../helpers/notification';

/**
 * No caching as of now
 */
export function loadNotifications(contentTypeId, newLang) {
    // If we are asking new language for notifications
    if (newLang) {
        localStorage.setItem('prefLang', newLang);
        preferredLanguage = newLang;
        // Clear prev notifications since they are in wrong language
        var div = document.getElementById('notifications');
        while (div.firstChild) {
            div.removeChild(div.firstChild);
        }
        // Get new notifications
        renderNotifications(newLang);
    }

    return getClient().getEntries({
        content_type: contentTypeId
    }).then(payload => {
        getCurrentBrowserFingerPrint().then((browserId) => {
            Object.keys(payload.items).map((id) => {

                // TODO: Filter only unread notifications if implemented

                const notification = payload.items[id];
                maybeShowNotification(notification, browserId);
            });
        });

        return payload.items
    })
}

export function renderNotifications(newLang) {
    getCurrentBrowserFingerPrint()
        .then((browserId) => {

            // TODO: Get unread notifications if implemented

            newLang === 'en' ? addToast('success', 'Language changed.') : addToast('success', 'Kieli vaihdettu.')
        });
}

const maybeShowNotification = (entry, browserId) => {
    const now = moment(new Date());
    const obj_show_until = moment(entry.show_until);
    if (now <= obj_show_until) {
        if (preferredLanguage === 'en' && entry.lang === 'en') {
            addToastWithGa_id('notify', entry.content, browserId, entry.read_id);
        }
        if (preferredLanguage === 'fi' && entry.lang === 'fi') {
            addToastWithGa_id('notify', entry.content, browserId, entry.read_id);
            // Default when no preferred lang set
        }
        if (!preferredLanguage) {
            // We default to fi
            if (entry.lang === 'fi') {
                addToastWithGa_id('notify', entry.content, browserId, entry.read_id);
            }
        }
    }
}
